import { Heart, Pill, Activity, Brain, Dumbbell, ExternalLink, Apple, Leaf } from "lucide-react";

const HEALTH_LINKS = [
  { name: "WebMD", icon: Heart, url: "https://www.webmd.com", color: "bg-blue-600" },
  { name: "Healthline", icon: Activity, url: "https://www.healthline.com", color: "bg-teal-600" },
  { name: "Mayo Clinic", icon: Heart, url: "https://www.mayoclinic.org", color: "bg-blue-700" },
  { name: "MedlinePlus", icon: Pill, url: "https://medlineplus.gov", color: "bg-green-600" },
  { name: "Vitamins Guide", icon: Pill, url: "https://www.webmd.com/vitamins/index", color: "bg-orange-600" },
  { name: "iHerb", icon: Leaf, url: "https://www.iherb.com", color: "bg-green-700" },
  { name: "Vitamin Shoppe", icon: Pill, url: "https://www.vitaminshoppe.com", color: "bg-purple-600" },
  { name: "Mindfulness", icon: Brain, url: "https://www.headspace.com", color: "bg-orange-500" },
  { name: "Calm App", icon: Brain, url: "https://www.calm.com", color: "bg-blue-500" },
  { name: "Fitness Tips", icon: Dumbbell, url: "https://www.bodybuilding.com", color: "bg-red-600" },
  { name: "MyFitnessPal", icon: Apple, url: "https://www.myfitnesspal.com", color: "bg-blue-600" },
  { name: "Nutrition Facts", icon: Apple, url: "https://www.nutritionvalue.org", color: "bg-green-500" },
  { name: "Sleep Foundation", icon: Activity, url: "https://www.sleepfoundation.org", color: "bg-indigo-600" },
  { name: "Mental Health", icon: Brain, url: "https://www.nimh.nih.gov", color: "bg-purple-700" },
];

const HealthWellnessPanel = ({ roomId }) => {
  if (roomId !== "health-wellness") return null;

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="health-wellness-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <Heart className="w-4 h-4" />
          🌿 HEALTH & WELLNESS
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-green-50 to-teal-50 max-h-[300px] overflow-y-auto retro-scrollbar">
        <div className="space-y-1">
          {HEALTH_LINKS.map((link, index) => {
            const Icon = link.icon;
            return (
              <button
                key={index}
                className={`${link.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openLink(link.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{link.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HealthWellnessPanel;
